import { createBindingApi } from '../../api/create-binding';
import { ApiHost, BindCardOptions } from '../../types';
import { fixDomainSfx, getDomainSfx } from '../../utils/common';
import { paymentForm } from '../payment-form';

import { getCreateBindingParams } from './utils';

export const bindCard = async (apiHost: ApiHost, options: BindCardOptions = {}) => {
    const { queryParams } = options;
    let { url } = options;

    if (url) {
        return paymentForm(apiHost, { url, queryParams });
    }

    url = await createBindingApi(apiHost, getCreateBindingParams(options));

    url = fixDomainSfx(url, getDomainSfx());

    return paymentForm(apiHost, { url, queryParams });
};
